import {MATCHING, MATCHING_WEIGHTS, DEVELOPER_EXPERIENCE} from "~/constants/wadConstants";

export function useMatching() {
  function getDeveloperSeniority(skillsExperiences: number[]) {
    let experiences = [...skillsExperiences]
    if (experiences.length > MATCHING.DEVELOPER_MINIMUM_SKILLS_FOR_AVG) {
      experiences.sort((a, b) => a - b)
      // take the upper half
      experiences = experiences.slice(Math.floor(experiences.length / 2))
    }

    const avg = experiences.length > 0 ? experiences.reduce((a, b) => a + b, 0) / experiences.length : 0

    if (avg <= 2)
      return MATCHING.DEVELOPER_SENIORITY.JUNIOR
    if (avg > 2 && avg <= 4)
      return MATCHING.DEVELOPER_SENIORITY.INTERMEDIATE
    if (avg > 4)
      return MATCHING.DEVELOPER_SENIORITY.SENIOR

    return MATCHING.DEVELOPER_SENIORITY.JUNIOR
  }

  function getMatchingPoints(
    jobSeniorities: any[],
    jobSkillIds: number[],
    jobLanguageId: number,
    developerSeniority: number,
    developerSkillIds: number[],
    developerLanguages: Array<{ id: number; level_id: number }>
  ) {
    // intersection of skills
    const matchingSkills = jobSkillIds.filter((id) =>
      developerSkillIds.includes(id)
    )
    const baseScore =
      jobSkillIds.length > 0 ? matchingSkills.length / jobSkillIds.length : 0

    let weightedScore =
      !jobSeniorities || jobSeniorities.length === 0 ? baseScore : 0

    if (jobSeniorities && jobSeniorities.length > 0) {
      jobSeniorities.forEach((jobSeniority) => {
        // safely get nested weights
        const seniorityWeights =
          MATCHING_WEIGHTS.seniority?.[developerSeniority]?.[jobSeniority.match_seniority] ?? [0, 1]

        const score = (baseScore + seniorityWeights[0]!) * seniorityWeights[1]!
        if (score > weightedScore) {
          weightedScore = score
        }
      })
    }

    if (jobLanguageId) {
      const lang = developerLanguages?.find((l) => l.id === jobLanguageId)
      const level = lang ? lang.level_id : 0
      const langWeight = MATCHING_WEIGHTS?.language?.[level] ?? 1
      weightedScore *= langWeight
    }

    switch (true) {
      case weightedScore > 0.79:
        return 5
      case weightedScore > 0.7:
        return 4.5
      case weightedScore > 0.65:
        return 4
      case weightedScore > 0.5:
        return 3.5
      case weightedScore > 0.46:
        return 3
      case weightedScore > 0.35:
        return 2.5
      case weightedScore > 0.3:
        return 2
      case weightedScore > 0.15:
        return 1.5
      case weightedScore > 0.05:
        return 1
      default:
        return 0
    }
  }

  function getMatchText(matchPoints: number): string {
    if (matchPoints === 0) return 'Check your match!'
    if (matchPoints === 5) return 'Perfect fit!'
    if (matchPoints >= 4) return 'Pretty good fit!'
    if (matchPoints >= 3) return 'Looks ok!'
    if (matchPoints >= 2) return 'Almost there!'
    if (matchPoints >= 1) return 'Try another card!'
    return ''
  }

  const getDeveloperExperienceLevel = (skillsExperiences: any[]) => {
    let experiences = [...skillsExperiences];
    if (skillsExperiences.length > 3) {
      experiences.sort();
      experiences = experiences.slice(Math.floor(experiences.length / 2))
    }
    const averageExperience = experiences.length ? (experiences.reduce((a, b) => a + b, 0) / experiences.length) : 0;

    switch (true) {
      case averageExperience <= 1:
        return DEVELOPER_EXPERIENCE.BEGINNER;
      case averageExperience <= 2:
        return DEVELOPER_EXPERIENCE.JUNIOR;
      case averageExperience <= 4:
        return DEVELOPER_EXPERIENCE.INTERMEDIATE;
      case averageExperience > 4:
        return DEVELOPER_EXPERIENCE.SENIOR;
    }
    return DEVELOPER_EXPERIENCE.BEGINNER;
  }

  return {
    getMatchingPoints,
    getDeveloperSeniority,
    getDeveloperExperienceLevel,
    getMatchText,
  }
}
